import React, { memo } from 'react';

const ArrowInner = () => (
    <svg viewBox="0 0 15 14">
        <path d="M7.23715 1.67573C7.61035 1.26861 7.58284 0.636044 7.17573 0.262852C6.76861 -0.110341 6.13604 -0.0828376 5.76285 0.324281L0.265644 6.32123C0.100761 6.49953 1.90735e-06 6.738 1.90735e-06 7C1.90735e-06 7.19196 0.0540877 7.37129 0.147854 7.52357C0.18071 7.57695 0.219041 7.62794 0.262849 7.67573L7.23715 1.67573ZM0.264375 7.6774L5.76285 13.6757C6.13604 14.0828 6.76861 14.1104 7.17573 13.7372C7.58284 13.364 7.61035 12.7314 7.23715 12.3243L3.27323 8H14C14.5523 8 15 7.55229 15 7C15 6.44772 14.5523 6 14 6H3.27324L7.23715 1.67573" />
    </svg>
);

export const Arrow = memo(ArrowInner);
